import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import compose from '../../hoc/compose';
import TextLabel from '../textLabel/textLabel';
import ArrowExpanded from './arrowExpanded';

var TreeSectionDivider = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TreeSectionDivider, _React$PureComponent);

  var _super = _createSuper(TreeSectionDivider);

  function TreeSectionDivider() {
    _classCallCheck(this, TreeSectionDivider);

    return _super.apply(this, arguments);
  }

  _createClass(TreeSectionDivider, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          alwaysShowSuffix = _this$props.alwaysShowSuffix,
          collapsed = _this$props.collapsed,
          dataHook = _this$props.dataHook,
          getClassName = _this$props.getClassName,
          hideBottomBorder = _this$props.hideBottomBorder,
          hideTopBorder = _this$props.hideTopBorder,
          label = _this$props.label,
          onClick = _this$props.onClick,
          shouldTranslate = _this$props.shouldTranslate,
          size = _this$props.size,
          suffix = _this$props.suffix;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook,
        className: getClassName(classNames('tree-section-divider', size, {
          top: !hideTopBorder,
          bottom: !hideBottomBorder
        })),
        onClick: onClick
      }, /*#__PURE__*/React.createElement("div", {
        "data-hook": "arrow-".concat(collapsed ? 'collapsed' : 'expanded'),
        className: classNames('tree-section-arrow', {
          collapsed: collapsed
        })
      }, /*#__PURE__*/React.createElement(ArrowExpanded, null)), /*#__PURE__*/React.createElement("div", {
        className: "tree-section-text tree-section-text-hack"
      }, /*#__PURE__*/React.createElement(TextLabel, {
        dataHook: "label",
        value: label,
        type: "T21",
        shouldTranslate: shouldTranslate
      })), suffix && /*#__PURE__*/React.createElement("div", {
        className: classNames('tree-section-suffix', {
          'show-suffix': alwaysShowSuffix
        })
      }, suffix));
    }
  }]);

  return TreeSectionDivider;
}(React.PureComponent);

TreeSectionDivider.displayName = 'TreeSectionDivider';
TreeSectionDivider.propTypes = {
  /** force suffix to always be visible */
  alwaysShowSuffix: PropTypes.bool,

  /** show arrow collapsed */
  collapsed: PropTypes.bool.isRequired,
  dataHook: PropTypes.string,
  hideBottomBorder: PropTypes.bool,
  hideTopBorder: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /** appears only on hover - ContextMenu, InfoIcon, etc. */
  suffix: PropTypes.node
};
TreeSectionDivider.defaultProps = {
  alwaysShowSuffix: false,
  hideBottomBorder: false,
  hideTopBorder: false,
  size: 'medium'
};
export default compose(TreeSectionDivider);